<template>
  <div class="panel-content" id="panel-content-container">
    <!--<HeightSwitcher
        :unlocked="heightSwitcherUnlocked"
        @click="heightSwitcherUnlocked = true"
      />-->
    <ActionCard
      v-for="k in actionKeys"
      :key="k"
      :actionKey="k"
      :id="k"
      @click="$emit('clickCard', k)"
    />
  </div>
</template>

<script>
import ActionCard from '@/components/ActionCard.vue'

export default {
  name: 'PanelContent',
  components: { ActionCard },
  data() {
    return {
      actionKeys: undefined,
    }
  },
  props: {
    level: Number,
    //scrollTo: { type: String, default: undefined },
  },
  computed: {
    unlockedActions() {
      return this.$store.state.unlockedActions[this.level]
    },
    lockedActions() {
      return Object.keys(this.$store.state.actions[this.level]).filter(
        (x) => !this.unlockedActions.includes(x)
      )
    },
  },
  mounted() {
    this.actionKeys = [...this.unlockedActions, ...this.lockedActions]
  },
  /*watch: {
    scrollTo(new_val) {
      if (!(new_val === undefined)) {
        //debugger
        const elem = document.getElementById(new_val)
        elem.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
          inline: 'nearest',
        })
        let scrollTimeout
        scrollTimeout = setTimeout(() => {
          this.scrollEnded()
        }, 100)

        const panel = document.getElementById('panel-content-container')
        panel.addEventListener(
          'scroll',
          function scrollListener() {
            console.log('scrolling')
            clearTimeout(scrollTimeout)
            scrollTimeout = setTimeout(() => {
              panel.removeEventListener('scroll', scrollListener)
              this.scrollEnded()
            }, 100)
          }.bind(this)
        )
      }
    },
  },*/
  /*methods: {
    scrollEnded() {
      console.log('SCROLL ENDED')
      this.updatePositions()
    },
    updatePositions() {
      this.$emit('scroll_end')
    },
  },*/
}
</script>

<style scoped>
.panel-content::-webkit-scrollbar {
  display: none;
}

.panel-content {
  position: absolute;
  top: 0px;
  bottom: 0px;
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  padding-bottom: 2rem;
  /*padding: 1rem 0rem 1rem 0rem;*/
  /*padding: 1rem 0rem 1rem 0rem;*/
  /* first part calculates the size of the header panel */
  /*padding: calc(3rem + 2.5rem + 1rem + 1rem + 2rem + 1rem) 0rem 1rem 0rem;*/
  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  transition: transform 0.5s;
}

/*.panel-content > * + * {
  margin-top: 2rem;
}*/
</style>
